export default "__VITE_ASSET__b5b3490e__"